/**
 * Return the translated string for bonus type name
 *
 * @param {Number} type struct value
 * @param {Function} trans localization function
 * @returns {String}  Bonus type string
 */
module.exports = function(type, trans) {
  if (!trans) return "";

  switch (type) {
    case 0:
      return trans("Exclusive Chapter");
    case 1:
      return trans("Story Branch");
    case 2:
      return trans("Writer Reveal");
    default:
      return "";
  }
};
